import { Expose, Type } from "class-transformer";
import { IsBoolean, IsNumber, IsOptional, IsString, ValidateNested } from "class-validator";

export class GroupBookingItem {
  @IsNumber()
  @Expose()
  id!: number;
  @IsString()
  @Expose()
  recordLocator!: string;
  @IsNumber()
  @Expose()
  grandTotal!: number;
  @IsString()
  @Expose()
  currency!: string;
  @IsBoolean()
  @Expose()
  isVoided!: boolean;
  @IsOptional()
  @IsString()
  @Expose()
  passengerName!: string | null;
  @IsOptional()
  @IsString()
  @Expose()
  passengerSurname!: string | null;
  @IsOptional()
  @IsString()
  @Expose()
  ticketNumber!: string;
  @IsBoolean()
  @Expose()
  isInOrder!: boolean;
  @IsBoolean()
  @Expose()
  isInvoiced!: boolean;
  @IsOptional()
  @IsNumber()
  @Expose()
  bookingItemGroupId!: number | null;
}

export class GroupBookingItems {
  @IsOptional()
  @IsNumber()
  @Expose()
  id!: null | number;
  @IsOptional()
  @IsString()
  @Expose()
  comment!: string;
  @Expose()
  recordStampId!: number;
  @Type(() => GroupBookingItem)
  @ValidateNested()
  @Expose()
  bookingItems!: Array<GroupBookingItem>;
}

export class GroupBookingItemModel extends GroupBookingItem {
  isInGroup = true;

  constructor(parent: GroupBookingItem) {
    super();
    this.id = parent.id;
    this.recordLocator = parent.recordLocator;
    this.grandTotal = parent.grandTotal;
    this.currency = parent.currency;
    this.isVoided = parent.isVoided;
    this.passengerName = parent.passengerName;
    this.passengerSurname = parent.passengerSurname;
    this.ticketNumber = parent.ticketNumber;
    this.isInOrder = parent.isInOrder;
    this.isInvoiced = parent.isInvoiced;
    this.isInGroup = true;
    this.bookingItemGroupId = parent.bookingItemGroupId;
  }
}
